export default {
    currentLevelIndex(state) {
        const index = state.levels.findIndex(level => !level.stars);
        return index > -1 ? index : 0;
    }
};
